import * as CryptoJS from 'crypto-js';
import { environment } from '../../../../environments/environment.dev';

export function encrypt(obj: any): string {
  try {
    const text = JSON.stringify(obj);
    return CryptoJS.AES.encrypt(text, environment.aesKey).toString();
  } catch (e) {
    console.error('Encrypt failed', e);
    return '';
  }
}
export function decrypt(cipher: string): any {
  try {
    const bytes = CryptoJS.AES.decrypt(cipher, environment.aesKey);
    const text = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(text);
  } catch (e) {
    console.error('Decrypt failed', e);
    return null;
  }
}